import type { AccordionProps } from "@mantine/core";
import { Accordion } from "@mantine/core";
import { IconChevronRight } from "@tabler/icons-react";

const borderRadius = 8;

type ExplorerResultsAccordionProps = Omit<AccordionProps, "styles">;

export function ExplorerResultsAccordion(props: ExplorerResultsAccordionProps) {
  return (
    <Accordion
      chevronPosition="left"
      chevron={<IconChevronRight size={16} />}
      styles={(theme) => {
        return {
          chevron: {
            "&[data-rotate]": {
              transform: "rotate(90deg)",
            },
            marginRight: 0,
          },
          control: {
            "&[data-active]": {
              borderBottom: "1px solid #E3E5E5",
            },
          },
          content: {
            padding: "8px 12px 16px 8px",
          },
          item: {
            borderRadius,
            overflow: "clip",
            border: "1px solid transparent",
            marginBottom: 2,
            "&:last-of-type": {
              marginBottom: 0,
            },
            "&:hover": {
              borderRadius,
              backgroundColor: theme.colors.gray[0],
              transition: "all 0.05s ease-in-out 0s",
              cursor: "pointer",
              border: `1px solid ${theme.colors.gray[3]}`,
            },
            "&[data-active]": {
              border: `1px solid ${theme.colors.gray[3]}`,
              boxShadow: "0px 2px 8px rgb(0 0 0 / 4%), 0px 1px 3px rgb(0 0 0 / 18%)",
            },
          },
        };
      }}
      {...props}
    />
  );
}

export function ExplorerResultsEntryAccordion(props: ExplorerResultsAccordionProps) {
  return (
    <Accordion
      chevronPosition="left"
      chevron={<IconChevronRight size={16} />}
      ml={{ base: 0, sm: 4 }}
      styles={(theme) => {
        return {
          chevron: {
            "&[data-rotate]": {
              transform: "rotate(90deg)",
            },
          },
          control: {
            borderRadius,
            border: "1px solid transparent",
            marginTop: 8,
            "&:hover": {
              borderRadius,
              backgroundColor: theme.colors.gray[1],
              transition: "all 0.05s ease-in-out 0s",
              cursor: "pointer",
              border: `1px solid ${theme.colors.gray[3]}`,
            },
          },
          content: {
            paddingRight: 0,
          },
          item: {
            borderBottom: "none",
          },
        };
      }}
      {...props}
    />
  );
}
